module.exports = __webpack_public_path__ + "static/media/Cleansed_MAP_VITALS_Equation.81ab83ca.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/informatics/Cleansed_MAP_VITALS_Equation.pdf
// module id = 407
// module chunks = 0